import { connect } from 'react-redux';
import { actions, selectors } from 'app-webtech-core';
import { loadedData } from 'app-modules/trivia/selectors';
import * as viralSelectors from 'app-modules/viral/selectors';
import { isCCEnabledSelector } from 'app-modules/player/selectors/isCCEnabled';
import { ViralOverlay } from '../components/ViralOverlay';
import { checkMobileOperatingSystem } from '../../application/utils/checkMobileOperatingSystem';
import {
  toggleCaption,
  ccSetSetting,
  internalResetCaptionsSettings,
  exitFullscreen,
  enterFullscreen,
} from '../actions';

const mapStateToProps = (state) => {
  const player = selectors.player.properties(state);
  const { isMobile } = checkMobileOperatingSystem();
  const viralContent = viralSelectors.properties(state).content;
  const podProperties = selectors.podTrackerAds.properties(state);
  const triviaData = loadedData(state);
  const { captionInUseIndex, captionList } = state.playerinternal;
  const clips = viralContent ? viralContent.clips : {};
  const clip = clips.find((clip) => clip._id === player.content.id);
  return {
    clip,
    isTrivia: !!triviaData,
    isStopped: player.status === 'STOPPED',
    showVideoControls: !podProperties.currentPlayingAd,
    haveCaptions: captionList.length > 0,
    captionIndex: captionInUseIndex,
    isMuted: player.mute,
    isCCEnabled: isCCEnabledSelector(state),
    isFullscreenDisabled: isMobile,
  };
};

const mapDispatchToProps = {
  toggleCaption,
  onCCSettingsChange: ccSetSetting,
  resetCCSettings: internalResetCaptionsSettings,
  exitFullscreen,
  enterFullscreen,
  ccMenuClose: actions.player.ccMenuClose,
};

export const ViralOverlayContainer = connect(mapStateToProps, mapDispatchToProps)(ViralOverlay);
